import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'ig',
    fullName: 'Igbo',
    nativeName: 'Igbo',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Ihe ịtụnanya na-abịa",
    landing_subtitle: "ArgVoid bụ ngwa na mmepe egwuregwu. Nọrọ na nche, ihe ọhụrụ na-abịa n'oge adịghị anya!",
    select_language: "Họrọ Asụsụ",
    search_placeholder: "Chọọ asụsụ...",
    terms_title: "Usoro ọrụ",
    policy_title: "amụma nzuzo",
    cookies_title: "Iwu kuki",
    terms_content: `
        <strong>1. Nnabata nke Okwu</strong><br>
        Site na ịnweta ArgVoid, anabatara Usoro ọrụ ndị a. Ọ bụrụ na ekwenyeghị na usoro ndị a, ekwesighi iji ọrụ ahụ.<br><br>

        <strong>2. Platform Usage</strong><br>
        A na-enye ArgVoid na ngwa ya "dị ka ọ dị" maka ebumnuche ozi na ihe okike. A ga-ejirịrị ọrụ a naanị maka ebumnuche iwu kwadoro.<br><br>

        <strong>3. Omume amachibidoro iwu</strong><br>
        A machibidoro ime ihe adịghị ike na saịtị, spamming, ma ọ bụ ịnwa ịnweta akụrụngwa n'enwetaghị ikike.<br><br>

        <strong>4. Disclaimer</strong><br>
        Enwere ike gbanwee ikpo okwu na ọrụ n'oge ọ bụla na-enweghị ọkwa. Ọ nweghị akwụkwọ ikike enyere maka oge ọrụ ma ọ bụ ịdị adị nke ọrụ ahụ.
    `,
    policy_content: `
        <strong>1. Nchịkọta ozi</strong><br>
        Ikpo okwu anaghị achọ njirimara onye ọrụ ma ọ bụ imepụta akaụntụ n'oge a. Ọ nweghị ozi njirimara (dị ka aha ma ọ bụ adreesị email) a na-anakọta nke ọma n'aka ndị ọbịa.<br><br>

        <strong>2. Ojiji Data</strong><br>
        Enwere ike ịnakọta nyocha nke enweghị aha, nke bụ isi, iji ghọta okporo ụzọ saịtị wee kwalite ngwa ndị ahụ. Ejikọtaghị data a na njirimara onye ọrụ.<br><br>

        <strong>3. Ọrụ Ndị ọzọ</strong><br>
        Enwere ike iji ndị na-eweta ndị ọzọ maka ọrụ nnabata na nyocha. Omume nzuzo nke ndị na-enye ndị a na-achịkwa data na-amaghị aha haziri na akụrụngwa ha.<br><br>

        <strong>4. Nchekwa data</strong><br>
        A na-emejuputa usoro nchekwa ezi uche dị na ya iji chebe ikpo okwu. Agbanyeghị, ọ nweghị usoro nnyefe na ịntanetị nwere nchekwa kpamkpam.<br><br>
    `,
    cookies_content: `
        <strong>1. Kedu ihe bụ kuki na nchekwa mpaghara?</strong><br>
        Kuki na ebe nchekwa ihe nchọgharị bụ obere faịlụ data echekwara na ngwaọrụ iji cheta mmasị nhazi n'ofe nleta.<br><br>

        <strong>2. Nzube ojiji</strong><br>
        A na-eji Nchekwa Mpaghara Ihe Nchọgharị nke ọma iji chekwaa ntọala nhazi, dịka:<br>
        - Mmasị asụsụ<br>
        - Nhazi interface onye ọrụ (dịka, nhazi ma ọ bụ ntọala isiokwu)<br>
        - cache ngwa nwa oge<br><br>

        <strong>3. Enweghị Tracking</strong><br>
        A naghị eji kuki na nchekwa mpaghara maka mgbasa ozi ma ọ bụ nleba anya nke ndị ọzọ. Data niile echekwara bụ nke ọma maka isi ọrụ nke ikpo okwu.<br><br>

        <strong>4. Control</strong><br>
        Enwere ike ikpochapụ data ihe nchọgharị n'oge ọ bụla site na ntọala ihe nchọgharị, nke ga-emegharị nhazi mpaghara ọ bụla.
    `,
    cookie_consent_text: "Anyị na-eji kuki ndị bụ isi iji hụ na ebe nrụọrụ weebụ na-arụ ọrụ nke ọma, dị ka ime ka nnọkọ gị na-arụ ọrụ, chekwaa mmasị asụsụ gị, yana nhazi omenala ndị ọzọ.",
    read_policy: "Gụọ amụma kuki",
    support_title: "Nkwado kọntaktị",
    support_subject_label: "Isiokwu",
    support_message_label: "Ozi",
    support_submit_button: "Ziga ozi",
    support_hint: "Cheta na: Nke a ga-emepe ngwa email nke ndabara iji zipu ozi ahụ.",
    support_success_msg: "Na-emepe ngwa email gị...",
    support_error_msg: "izipu ozi agaghị. Biko nwaa ọzọ ma emechaa.",
    explorer_title: "Explorer",
    history_title: "Akụkọ ihe mere eme",
    animation_title: "Anụmanụ",
    config_title: "Nhazi",
    tool_mouse: "Họrọ (Ctrl+M)",
    tool_brush: "ahịhịa (Ctrl+B)",
    tool_brush_mode: "Ụdị ngbanwe (siri ike/dị ọcha)",
    tool_eraser: "Nchicha (Ctrl+E)",
    tool_brush_size: "Gbanwee nha ahịhịa",
    tool_bucket: "Mejupụta (Ctrl+F)",
    tool_eyedropper: "Eyedropper",
    tool_grid: "Grid (Ctrl+Shift+B)",
    tool_rotate: "Bugharịa (Ctrl+Shift+R)",
    tool_flip_h: "Tụgharịa H (Ctrl+Shift+H)",
    tool_flip_v: "Tụgharịa V (Ctrl+Shift+V)",
    tool_transpose: "Nyefee (Ctrl+Shift+T)",
    label_width: "Obosara",
    label_height: "Ogologo",
    label_frames: "Ọnụọgụ nke Frames",
    label_animation: "Ụdị animation",
    label_background_color: "Agba ndabere",
    label_interval: "Ogologo oge",
    tool_anim_config: "Nhazi ihe nkiri",
    label_new_width: "Obosara ọhụrụ",
    label_new_height: "Ogologo Ọhụrụ",
    label_apply: "Tinye",
    label_colors: "Agba",
    label_size: "Nha",
    label_tolerance: "Ndidi",
    val_horizontal: "Kehoraizin",
    val_vertical: "kwụ ọtọ",
    val_sequence: "Usoro",
    val_bounce: "Bilie",
    val_random: "Random",
    val_solid: "siri ike",
    val_clear: "Kpochapụ",
    action_add_sheet: "Mpempe akwụkwọ ọhụrụ",
    action_import: "Bubata",
    action_export: "Mbupụ",
    action_sort_projects: "Hazie",
    sort_date_old: "Nke kacha ochie",
    sort_date_new: "Nke Kacha ọhụrụ",
    sort_name_az: "Aha (A-Z)",
    sort_name_za: "Aha (Z-A)",
    action_new_sprite: "Ọhụrụ Sprite",
    action_new_project: "Ọrụ ọhụrụ",
    modal_save_all_title: "Chekwaa mgbanwe niile",
    modal_save_all_desc: "Họrọ akụ ị ga-echekwa:",
    modal_save_selected: "Chekwa ahọpụtara",
    action_saved: "Echekwara",
    modal_create_sprite_title: "Mepụta Sprite Ọhụrụ",
    modal_create_project_title: "Mepụta Ọrụ Ọhụrụ",
    modal_add_sheet_title: "Tinye akwụkwọ ọhụrụ",
    modal_rename_sheet_title: "Nyegharịa mpempe akwụkwọ aha",
    modal_rename_sprite_title: "Kpọgharia aha Sprite",
    modal_delete_sprite_title: "Hichapụ Sprite",
    modal_delete_project_title: "Hichapụ Project",
    modal_delete_sheet_title: "Hichapụ mpempe akwụkwọ",
    placeholder_sprite_name: "Aha",
    placeholder_project_name: "Aha",
    placeholder_sheet_name: "Aha",
    placeholder_new_name: "Aha ọhụrụ",
    action_create: "Mepụta",
    action_add: "Tinye",
    action_rename: "Nyegharịa aha",
    action_duplicate: "Megharịa",
    action_delete: "Hichapụ",
    action_cancel: "Kagbuo",
    confirm_delete_sprite: "Ị ji n'aka na ịchọrọ ihichapụ sprite a?",
    confirm_delete_project: "Ị ji n'aka na ịchọrọ ihichapụ ọrụ a? A ga-ewepụ sprites niile.",
    confirm_delete_sheet: "Ị ji n'aka na ịchọrọ ihichapụ mpempe akwụkwọ a?",
    err_select_sprite: "Biko buru ụzọ họrọ sprite.",
    err_select_project: "Biko buru ụzọ họrọ oru ngo.",
    err_name_empty: "Aha enweghị ike ịbụ ihe efu.",
    err_sprite_exists: "A sprite nwere aha ahụ adịlarị.",
    err_project_exists: "Ọrụ nwere aha ahụ adịlarị.",
    err_no_content: "Enweghị ọdịnaya iji chekwaa.",
    err_no_changes: "Enweghị mgbanwe iji chekwaa.",
    err_delete_last_sheet: "Enweghị ike ihichapụ akwụkwọ ikpeazụ.",
    err_extract_frames: "Enweghị ike wepụ fremu ọ bụla.",
    err_indexeddb: "Echekwaghị na mpaghara. Ihe nchọgharị gị nwere ike ọ gaghị akwado IndexedDB.",
    msg_upload_success: "Bulite aga nke ọma: {0}",
    msg_upload_failed: "Nbulite agaghị: {0}",
    msg_save_success: "Chekwa nke ọma.",
    msg_saving: "Na-echekwa...",
    msg_multi_save_result: "Echekwara {0} akụ. {1} ọdịda.",
    menu_title: "NchNhr",
    menu_save: "Chekwa",
    menu_save_all: "Chekwaa ha niile",
    menu_support: "Nkwado kọntaktị",
    label_local_storage: "Nchekwa mpaghara",
    label_sign_in: "Banye",
    modal_export_title: "Mbupụ Sprite",
    label_filename: "Aha faịlụ",
    label_format: "Usoro",
    action_export_confirm: "Mbupụ",
};

export default translations;
